import '@operato/dataset/ox-data-sample-view.js'
import '@operato/dataset/ox-data-ooc-brief-view.js'
import '@things-factory/worklist/dist-client/components/activity-thread-timeline.js'

import gql from 'graphql-tag'
import { PropertyValues, html, css, nothing } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { PageView } from '@operato/shell'
import { i18next, localize } from '@operato/i18n'
import { client } from '@operato/graphql'

/**
 * 이 페이지는 여러개의 Data Sample을 한번에 프린트하기 위한 용도로 사용되는 페이지이다.
 */
@customElement('data-samples-page')
export class DataSamplesPage extends localize(i18next)(PageView) {
  static styles = [
    css`
      :host {
        display: block;
        overflow: auto;
      }

      .end {
        page-break-after: always;
        break-after: always;
      }
    `
  ]

  @state() dataSamples?: any[]

  get context() {
    return {
      title: i18next.t('title.data-sample view')
    }
  }

  render() {
    return this.dataSamples?.map(dataSample => {
      if (dataSample?.dataOoc) {
        var reviewActivityThread = dataSample.dataOoc.reviewActivityInstance?.activityThreads?.[0]
        var resolveActivityThread = dataSample.dataOoc.resolveActivityInstance?.activityThreads?.[0]
      } else {
        var reviewActivityThread = dataSample?.reviewActivityInstance?.activityThreads?.[0]
      }

      return html`
        ${!dataSample.dataOoc
          ? html` <ox-data-sample-view .dataSample=${dataSample}></ox-data-sample-view> `
          : html` <ox-data-ooc-brief-view .dataOoc=${dataSample.dataOoc}></ox-data-ooc-brief-view>`}
        ${reviewActivityThread
          ? html`
              <activity-thread-timeline
                subtitle=${String(i18next.t(dataSample?.dataOoc ? 'label.ooc review timeline' : 'label.datasample review timeline'))}
                .activityThread=${reviewActivityThread}
                short-form
              ></activity-thread-timeline>
            `
          : nothing}
        ${resolveActivityThread
          ? html`
              <activity-thread-timeline
                subtitle=${String(i18next.t('label.ooc resolve timeline'))}
                .activityThread=${resolveActivityThread}
                short-form
              ></activity-thread-timeline>
            `
          : nothing}
        <div class="end"></div>
      `
    })
  }

  updated(changes: PropertyValues<this>) {}

  pageUpdated(changes: any, lifecycle: any, before: any) {
    if (this.active) {
      /*
       * this page is activated
       */
      const { ids = '' } = lifecycle.params

      this.fetchSamples(ids.split('|').map(id => id.trim()))
    } else {
      /* this page is deactivated */
    }
  }

  async fetchSamples(ids: string[]) {
    const filters = [
      {
        name: 'id',
        operator: 'in',
        value: ids
      }
    ]

    const response = await client.query({
      query: gql`
        query ($filters: [Filter!]) {
          dataSamples(filters: $filters) {
            items {
              id
              name
              description
              useCase
              key01
              key02
              key03
              key04
              key05
              data
              ooc
              oos
              updatedAt
              collectedAt
              updater {
                id
                name
              }
              dataSet {
                id
                name
                description
              }
              dataItems {
                name
                description
                active
                hidden
                tag
                group
                type
                unit
                options
                quota
                spec
                stat
              }
              judgment
              workDate
              workShift
              reviewActivityInstance {
                ...ActivityInstanceFragment
              }
              dataOoc {
                name
                description
                useCase
                dataSet {
                  id
                  name
                }
                key01
                key02
                key03
                key04
                key05
                partitionKeys
                dataItems {
                  name
                  description
                  active
                  hidden
                  tag
                  group
                  type
                  unit
                  options
                  quota
                  spec
                  stat
                }
                data
                rawData
                judgment
                ooc
                oos
                state
                history
                workDate
                workShift
                correctiveInstruction
                correctiveAction
                reviewedAt
                reviewer {
                  id
                  name
                }
                correctedAt
                corrector {
                  id
                  name
                }
                updater {
                  id
                  name
                }
                updatedAt
                collectedAt
                reviewActivityInstance {
                  ...ActivityInstanceFragment
                }
                resolveActivityInstance {
                  ...ActivityInstanceFragment
                }
              }
            }
          }
        }

        fragment ActivityInstanceFragment on ActivityInstance {
          activityThreads {
            assignee {
              name
            }
            output
            activityApprovals {
              judgment
              approver {
                name
              }
              comment
              createdAt
              updatedAt
              terminatedAt
            }
            activityThreadHistories {
              transaction
              reason
              updater {
                name
              }
              updatedAt
              state
              output
            }
          }
        }
      `,
      variables: {
        filters
      }
    })

    this.dataSamples = response.data.dataSamples.items
  }
}
